import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/service/config.service';

@Component({
  selector: 'app-pag-not-found',
  templateUrl: './pag-not-found.component.html',
  styles: [
  ]
})
export class PagNotFoundComponent implements OnInit {

  constructor(public _config: ConfigService) { }

  ngOnInit(): void {
  }

}
